import "../../css/fonts.css";
import "../../css/container.css";
import "../../css/misc.css";

import { ContainerNoBg } from "../../components/container.no.bg";
import { useIsMobile } from "../../hooks/is.mobile";
import Posts from "../../components/posts/posts";
export const News: React.FC<any> = () => {
  const isMobile = useIsMobile();
  return (
    <div>
      <ContainerNoBg>
        <div
          style={{
            paddingTop: isMobile ? "15vw" : "10vw",
          }}
        >
          <Posts />
        </div>
      </ContainerNoBg>
    </div>
  );
};
